import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Expressions } from '../interfaces/expressions';
import * as faceapi from 'face-api.js';

@Injectable({
  providedIn: 'root',
})
export class FaceApiService {
  modelsLoaded$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  metadata$: BehaviorSubject<
    {
      landmark: any;
      expressions: Expressions;
      box: any;
      score: number;
    } | false
  > = new BehaviorSubject<{
    landmark: any;
    expressions: any;
    box: any;
    score: number;
  } | false>(false);

  private _detecting = false;

  constructor() {
    this._loadModels();
  }

  private async _loadModels(): Promise<void> {
    const modelPath = './../../assets/models';
    await Promise.allSettled([
      faceapi.nets.ssdMobilenetv1.loadFromUri(modelPath),
      faceapi.nets.faceLandmark68Net.loadFromUri(modelPath),
      faceapi.nets.faceExpressionNet.loadFromUri(modelPath),
    ]);
    this.modelsLoaded$.next(true);
  }

  async getMetadataFromFace(videoElement: any): Promise<void> {
    if (!this.modelsLoaded$.value || this._detecting) return;
    this._detecting = true;
    try {
      // detectSingleFace es más eficiente que detectAllFaces cuando solo
      // se necesita el primer resultado: termina al encontrar la primera cara.
      const detection = await faceapi
        .detectSingleFace(videoElement.nativeElement)
        .withFaceLandmarks()
        .withFaceExpressions();

      if (detection) {
        const landmark = detection.landmarks || null;
        const expressions = detection.expressions || null;
        const box = detection.detection?.box || null;
        const score = detection.detection?.score || 0;

        this.metadata$.next({
          landmark,
          expressions,
          box,
          score,
        });
      } else {
        this.metadata$.next(false);
      }
    } catch {
      this.metadata$.next(false);
    } finally {
      this._detecting = false;
    }
  }
}
